module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_305582.8bfa8788.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetAlTFF/FormatoSimplificado_305582.pdf
// module id = 814
// module chunks = 0